import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import SelectBox from 'components/form/SelectBox'

export const AGGREGATE_TYPES = [
  { id: 'ADACCOUNT', name: '계정' },
  { id: 'BIZCHANNEL', name: '비즈채널' },
  { id: 'CREATIVE', name: '광고소재 관리' },
  { id: 'CAMPAIGN', name: '캠페인' },
  { id: 'ADGROUP', name: '그룹' },
  { id: 'KEYWORD', name: '키워드' },
  { id: 'CREATIVE_LINK', name: '소재' },
  { id: 'RESTRICTION_IP', name: '광고노출 제한' },
]

const AggregateTypeFilter = ({ onSelectAggregateType }) => {
  const { selectedAggregateType } = useSelector(state => state.editlog)

  return (
    <SelectBox
      placeholder="유형 선택"
      value={selectedAggregateType}
      onValueChange={onSelectAggregateType}>
      {AGGREGATE_TYPES.map(type => (
        <SelectBox.Item key={type.id} value={type}>
          {type.name}
        </SelectBox.Item>
      ))}
    </SelectBox>
  )
}

export default AggregateTypeFilter

AggregateTypeFilter.propTypes = {
  onSelectAggregateType: PropTypes.func,
}
